import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { CarePlanStore } from '../../care-plan.store';
import { CarePlanCaseGroup } from '../case-grouping';
import { CaseCardComponent } from '../case-card/case-card.component';

/**
 * A collapsible banner plus its case rows. The status dot only appears when
 * the list is grouped by status — for Domain / Client goal groups there is no
 * single status to colour it with.
 */
@Component({
  selector: 'bn-case-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CaseCardComponent],
  templateUrl: './case-group.component.html',
  styleUrl: './case-group.component.scss',
})
export class CaseGroupComponent {
  private readonly _store = inject(CarePlanStore);

  readonly group = input.required<CarePlanCaseGroup>();

  protected readonly collapsed = signal(false);

  protected readonly statusKey = computed(() =>
    this._store.groupBy() === 'status' ? this.group().key : null
  );

  protected readonly caseCountLabel = computed(() => {
    const count = this.group().cases.length;
    return `${count} ${count === 1 ? 'case' : 'cases'}`;
  });

  toggle(): void {
    this.collapsed.update((value) => !value);
  }
}
